// extracted by mini-css-extract-plugin
module.exports = {"container":"MobileHeader_container__RBABT","side":"MobileHeader_side__mS97e","link":"MobileHeader_link__JYx94"};